import { cva, type VariantProps } from 'class-variance-authority';
import { cn, identityColor, identityTextColor, initials } from '../lib/cn';

const avatar = cva(
  'inline-flex shrink-0 items-center justify-center rounded-full font-bold select-none',
  {
    variants: {
      size: {
        xs: 'size-6 text-[10px]',
        sm: 'size-8 text-[12px]',
        md: 'size-10 text-[14px]',
        lg: 'size-13 text-[17px]',
        xl: 'size-16 text-[22px]',
      },
      tone: {
        /* `identity` deriva a cor do proprio endereco - ver identityColor. */
        identity: '',
        blue: 'bg-wc-blue text-white',
        dark: 'bg-wc-dark text-white',
        light: 'bg-selected text-wc-blue',
      },
    },
    defaultVariants: { size: 'md', tone: 'identity' },
  },
);

export interface AvatarProps
  extends Omit<React.HTMLAttributes<HTMLSpanElement>, 'children'>, VariantProps<typeof avatar> {
  /** Nome ou e-mail. Gera iniciais e, no tom identity, a cor. */
  name: string;
  src?: string | undefined;
}

export function Avatar({ className, size, tone, name, src, style, ...props }: AvatarProps) {
  const text = initials(name);
  const identityStyle =
    tone === undefined || tone === 'identity'
      ? { backgroundColor: identityColor(name), color: identityTextColor(identityColor(name)) }
      : undefined;

  if (src !== undefined) {
    return (
      <img
        src={src}
        alt={name}
        className={cn(avatar({ size, tone }), 'object-cover', className)}
        style={style}
      />
    );
  }

  return (
    <span
      // O nome ja aparece ao lado em toda tela do produto; as iniciais sao decoracao.
      aria-hidden="true"
      className={cn(avatar({ size, tone }), className)}
      style={{ ...identityStyle, ...style }}
      {...props}
    >
      {text}
    </span>
  );
}
